/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://hpgj7d3zwjhlbb76dq23zb2xp4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-mhbi6amlpjctbkoi5jw4r55oqi",
    "aws_cloud_logic_custom": [
        {
            "name": "eta",
            "endpoint": "https://u9u817z7l3.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        },
        {
            "name": "equipmentnew",
            "endpoint": "https://k0uhot18c2.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:0e414422-bcae-4420-9196-87b7e0265d69",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_EZj28um7i",
    "aws_user_pools_web_client_id": "3n2qfqvrr7i16703h8g5v5g0i3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "equipmentdb-staging",
            "region": "us-east-1"
        },
        {
            "tableName": "etadb-staging",
            "region": "us-east-1"
        },
        {
            "tableName": "equipmentnewdb-staging",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
